import config from "../config";

/**
 * The LaunchDarkly gate on browser automation (Q153, Q163).
 *
 * The `browser-use` flag is targeted on the `user`
 * context this app already sends, matched by its `mspName` attribute. So the page evaluates it
 * from the flags it holds -- there is nothing to ask the server for.
 *
 * With the flag off, Google Workspace is configured the way it was before Theo could drive a
 * browser: the technician's own service-account JSON, tested and saved by hand.
 */
const BROWSER_USE_FLAG_KEYS = ["browser-use", "browserUse", "browseruse"];

function isLdFlagEnabled(flags: Record<string, unknown>, ...keys: string[]): boolean {
  for (const key of keys) {
    const value = flags[key];
    if (value === true) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "on" || normalized === "yes" || normalized === "1") {
        return true;
      }
    }
  }
  return false;
}

export function isBrowserUseLdEnabled(flags: Record<string, unknown>): boolean {
  // No client-side id means no flags at all, so local development would lose the feature
  // entirely rather than have it switched off.
  if (process.env.NODE_ENV === "development" && !config.launchdarklyClientSideId) {
    return true;
  }
  return isLdFlagEnabled(flags, ...BROWSER_USE_FLAG_KEYS);
}
